import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IServiceProviderSearchParameters } from 'src/app/Models/IServiceProviderSearchParameters';

@Component({
  selector: 'app-_120ServiceRegistersReportParams',
  templateUrl: './_120ServiceRegistersReportParams.component.html',
  styleUrls: ['./_120ServiceRegistersReportParams.component.css']
})
export class _120ServiceRegistersReportParamsComponent implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  date: Date; //datepicker
  //selectedValue: string = 'val1';  //radiobutton
  selectedPAU: SelectItem;
  selectedSite: SelectItem;
  selectedServiceProvider: SelectItem;
  academicYear: SelectItem;
  attendancePeriod: string;//dropdowns
  _academicYear: string = null; _attendancePeriodValue: string = null; _attendancePeriodLabel: string = null; _PAUid: string = null; _siteId: string = null; _serviceProvider: string = null; _startDate: string = null;
  public showSpinner: boolean = false;
  public isLoading: boolean = false;
  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  attendancePeriodList: ILookupBase[] = [{ value: null, label: "-- Select Attendance Period --", shortText: null, updatedOn: null }];
  academicYearList: ILookupBase[] = [{ value: null, label: "-- Select Academic Year --", shortText: null, updatedOn: null }];
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }];
  lookupSProvidersList: ILookupBase[] = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
  }


  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this.isLoading = true;
    this._lookupService.getLookupAcademicYearList(this._baseUrl + 'api/Lookup/GetAcademicYearList/')
      .subscribe((res: ILookupBase[]) => {
        this.academicYearList = res.reverse();
        if (this._academicYear == null) {
          this.academicYear = this.academicYearList[0];
          this._academicYear = this.academicYear.label;
        }
        let acYear = (new Date().getMonth() + 1) > 7 ? new Date().getFullYear() + "-" + (new Date().getFullYear() + 1) : (new Date().getFullYear() - 1) + "-" + new Date().getFullYear();
        this._lookupService.getLookupAttendancePeriod(this._baseUrl + 'api/Lookup/GetAttendancePeriodList/' + (this._academicYear == null ? acYear : this._academicYear))
          .subscribe((res: ILookupBase[]) => {
            this.attendancePeriodList = res.reverse();
            this.attendancePeriod = this.attendancePeriodList[0].value;

            //replace call to setAttendancePeriod since this method is expecting event insead of string
            this._attendancePeriodValue = this.attendancePeriodList[0].value;
            this._attendancePeriodLabel = this.attendancePeriodList[0].label;
            this._startDate = this._attendancePeriodLabel.slice(this._attendancePeriodLabel.indexOf(' - ') + 3, this._attendancePeriodLabel.indexOf(' to '))

            //SD 6/4/2026 fix the provider list loading on init when the attendance period is auto selected on init. This was causing the provider list to not load until the user reselects the attendance period after the initial load.
            this.loadPAUsAndSites();
          },
            err => {
              console.error(err);
              this.isLoading = false;
            }
            
          );
      },
        err => {
          console.error(err);
          this.isLoading = false;
        }
    );

    //this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
    //  .subscribe((res: ILookupBase[]) => {
    //    this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
    //    this.selectedPAU = this.lookupPAUList[0];
    //    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
    //      .subscribe((res: ILookupBase[]) => {
    //        if (!res || res.toString() === "") {
    //          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
    //        }
    //        else {
    //          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
    //          this.selectedSite = this.lookupSiteList[0];

    //          this.getProviderList();
    //        }
    //      },
    //        err => console.error(err)
    //      );
    //  },
    //    err => console.error(err)
    //);


  }


  loadPAUsAndSites(): void {
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
        this.selectedPAU = this.lookupPAUList[0];
        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];
              this.getProviderList();

            }
            this.isLoading = false;
            
          },
            err => {
              console.error(err);
              this.isLoading = false;
            }
          );
      },
        err => {
          console.error(err);
          this.isLoading = false;
        }
      );
  }

  LookupSites(id): void {
    this._PAUid = id.value;
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
        .subscribe((res: ILookupBase[]) => {
          if (!res || res.toString() === "") {
            this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
          }
          else {
            this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
            this.selectedSite = this.lookupSiteList[0];

            this.getProviderList();
          }
        },
          err => console.error(err)
        );
  }

  setSite(id): void {
    this._siteId = id.value;

    this.getProviderList();
  }

  setAcademicYear(id): void {
    this._academicYear = id.value;
    this.LoadLookupValues()
  }
  setAttendancePeriod(id): void {
    this._attendancePeriodValue = id.value;
    this._attendancePeriodLabel = this.attendancePeriodList.find(x => x.value === id.value).label;
    this._startDate = this._attendancePeriodLabel.slice(this._attendancePeriodLabel.indexOf(' - ') + 3, this._attendancePeriodLabel.indexOf(' to '))

    this.getProviderList();
  }
  selectServiceProvider(id): void { this._serviceProvider = id.value }

  getProviderList() {
    //get attendance period
    let periodValue = this.attendancePeriod;
    let periodSelectItem = this.attendancePeriodList.find(x => x.value === periodValue);
    
    let startDate = this.date;
    let endDate = this.date
    if (periodSelectItem) {
      let periodLabel = periodSelectItem.label;
      let startDateString = periodLabel.slice(periodLabel.indexOf(' - ') + 3, periodLabel.indexOf(' to '));
      startDate = new Date(startDateString);
      let endDateString = periodLabel.slice(periodLabel.indexOf(' to ') + 3);
      endDate = new Date(endDateString);
    }

    //Service Provider Lookup
    let serviceProviderParams: IServiceProviderSearchParameters = {} as IServiceProviderSearchParameters;
    serviceProviderParams.startDate = startDate
    serviceProviderParams.endDate = endDate
    serviceProviderParams.siteIdArray = this.getSiteIdList().split('^');


    this._lookupService.getLookupServiceProviders(this._baseUrl + 'api/Lookup/GetServiceProviderList/', serviceProviderParams)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSProvidersList = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSProvidersList = [{ value: null, label: "-- ALL Service Providers --", shortText: null, updatedOn: null }].concat(res);
          this.selectedServiceProvider = this.lookupSProvidersList[0];
        }
      },
        err => console.error(err)
      ); 
  }

  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
    }
  }

  viewReport() {
    let reportParamArray: IReportParameter[] = [];
    var selectedPAUValue = this.lookupPAUList.find(x => x.value === this._PAUid).label;
    var selectedSiteValue = this.lookupSiteList.find(y => y.value === this._siteId).label;
    var selectedServiceProvider = this.lookupSProvidersList.find(z => z.value === this._serviceProvider).label;
    var selectedAcademicYear = this.academicYearList.find(l => l.value === this._academicYear).label;
    var selectedAttendacePeriod = this.attendancePeriodList.find(k => k.value === this.attendancePeriod).label;
    var serviceProviderStaffIdList: string = '';
    var j = this.lookupSProvidersList.length;

    if (selectedServiceProvider == "-- ALL Service Providers --") {
      if (j > 1) {
        for (var i = 1; i < j; i++) {
          serviceProviderStaffIdList += this.lookupSProvidersList[i].value + '^';
        }
        serviceProviderStaffIdList = serviceProviderStaffIdList.slice(0, serviceProviderStaffIdList.length - 1).replace('undefined', '');
      }
    }
    else {
      serviceProviderStaffIdList = this.lookupSProvidersList.find(z => z.value === this._serviceProvider).value;
    }

    reportParamArray.push(
      { parameterName: 'AcademicYear', parameterValue: this._academicYear != null && this.academicYear.label != "-- ALL Academic Years --" ? this._academicYear : 'All Academic Years' },  // TODO !   ALL YEARS ??
      { parameterName: 'AttendancePeriod', parameterValue: selectedAttendacePeriod }, 
      { parameterName: 'PAU_Name', parameterValue: (this.selectedPAU != null && selectedPAUValue != '-- ALL PAUs --') ? selectedPAUValue : 'All PAUs' },
      { parameterName: 'SiteName', parameterValue: (this.selectedSite != null && selectedSiteValue != "-- Select PAU to view sites --") ? selectedSiteValue.replace('-- ', '').replace(' --', '') : 'All Sites' },
      { parameterName: 'ServiceProviderName', parameterValue: (this.selectedServiceProvider != null && selectedServiceProvider != "-- ALL Service Providers --") ? selectedServiceProvider : 'All Service Providers' },
      { parameterName: 'SiteIdList', parameterValue: this.getSiteIdList().replace('undefined', '') },
      { parameterName: 'ServiceProviderStaffIdList', parameterValue: serviceProviderStaffIdList != null ? serviceProviderStaffIdList.replace('null', '') : '' },
      { parameterName: 'StartDate', parameterValue: this._startDate }
    );

    let now = new Date();
    let localReportFileName = '120-ServiceRegisters_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = "IEP_SpecialEd_ServiceRegister";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this.showSpinner = true;
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
